import { AppRoutingService } from '@core/app-routing.service';
import { NavigationMenuItem } from '@models/navigation-menu-item';
import { IUser } from '@models/user';
import { zbContactUsMenu } from './contact-us-menu';

export const PARENT_CHILDREN_MENU_ID = 'parentChildren';

/**
 * Builds the primary menu item for the parent portal.
 *
 * - 1 child with 1 classroom → routed link directly to the overview page (ROUTED INTERNAL LINK in header template).
 * - 1 child with multiple classrooms, or multiple children →
 *  dropdown button (PARENT CHILDREN DROPDOWN in header template).
 *
 * @param children The list of students associated with the current parent user
 * @param contextStudent The student currently in ParentFacade.studentContext$.
 *   This is the student displayed in the header. All other students will be available through the dropdown.
 */
export function buildParentMenuItems(
  children: IUser[],
  contextStudent: IUser | null,
  appRoutingService: AppRoutingService,
): NavigationMenuItem[] {
  const contactMenu: NavigationMenuItem = { ...zbContactUsMenu, label: 'helpLink' };
  const menus: NavigationMenuItem[] = [contactMenu];

  if (!children?.length) return menus;

  // Children are already alphabetized
  const firstChild = children[0];
  const activeChild = contextStudent ?? firstChild;
  const isSingleChild = children.length === 1;
  // Single child with 0 or 1 classroom
  const isButtonWithoutDropdown = isSingleChild && firstChild.classrooms?.length < 2;

  if (isButtonWithoutDropdown) {
    const classroom = firstChild.classrooms[0];

    let route: string;
    if (firstChild.classrooms?.length) {
      route = appRoutingService
        .getParentsStudentClassroomRoute(firstChild.userId, classroom.classroomId).toString();
    } else {
      route = appRoutingService.getParentNoClassroomForStudentRoute(firstChild.userId).toString();
    }

    menus.unshift({
      id: PARENT_CHILDREN_MENU_ID,
      label: activeChild.fullName,
      isRouted: true,
      isExternal: false,
      route,
      weight: -10,
      iconClass: 'fa-user-circle',
    });
  } else {
    menus.unshift({
      id: PARENT_CHILDREN_MENU_ID,
      label: activeChild.fullName,
      isRouted: false,
      isExternal: false,
      weight: -10,
      iconClass: 'fa-user-circle',
    });
  }

  return menus;
}
